import { useState, useEffect } from "react";
import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./ManagingVersions.css";
import * as XLSX from "xlsx";
import { posServices } from "../../Services";
import { posVersionService } from "../../Services/posVersion.services";
const ImportFileModal = ({ showFileModal, setShowFileModal }) => {
  const { t: translator } = useTranslation();
  const [typeSelectedValue, setTypeSelectedValue] = useState(1);
  const [posVersions, setPosVersions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState([]);
  const [selectedVersion, setSelectedVersion] = useState();

  useEffect(() => {
    posServices.getPosVersions().then((res) => {
      setPosVersions(res?.data);
    });
  }, []);

  const handleRadioChange = (event) => {
    console.log("EVENT:", event.target.value);
    const newValue = event.target.value;
    setTypeSelectedValue(Number(newValue));
  };
  const handleSaveFile = async () => {
    if (!values?.length) return;

    setLoading(true);
    try {
      console.log("VALUES:", values);
      await posVersionService.posAddToSelectedIctVersion(
        Number(selectedVersion),
        typeSelectedValue,
        values
      );  
      //poslati na backend values i type value
    } catch (error) {
      console.error(error);
    } finally {
      setShowFileModal(false);
      setValues();
      setLoading(false);
    }
  };
  const handleFileChange = async (e) => {
    const uploadedFile = e.target.files[0];
    if (!uploadedFile) return;

    setLoading(true);

    try {
      const data = await uploadedFile.arrayBuffer();
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 }).slice(1);

      const flatValues = rows
        .flat()
        .filter((v) => v !== undefined && v !== null && v !== "");

      setValues(flatValues);
      console.log("Importane vrijednosti:", flatValues);
    } catch (err) {
      console.error("Greška pri čitanju fajla:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Modal
        show={showFileModal}
        centered
        onHide={() => setShowFileModal(false)}
      >
        <Modal.Header>
          <Modal.Title>{translator("ManagingVersion-ImportFile")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <label>{translator("ImportFile-DocumentType")}</label>
            <div className="radioButton">
              <div>
                <input
                  name="selectionType"
                  type="radio"
                  value={1}
                  style={{ marginRight: "2px" }}
                  checked={typeSelectedValue === 1}
                  onChange={handleRadioChange}
                />
                <label>{translator("ICT number")}</label>
              </div>
              <div>
                <input
                  type="radio"
                  name="selectionType"
                  value={2}
                  style={{ marginRight: "2px" }}
                  checked={typeSelectedValue === 2}
                  onChange={handleRadioChange}
                />
                <label>{translator("Serial number")}</label>
              </div>
            </div>
            <input
              type="file"
              className="form-control-file"
              name="file"
              onChange={handleFileChange}
            />

            {values?.length > 0 && (
              <div
                style={{ margin: 5, marginBottom: "20px" }}
                className="alert alert-warning"
                role="alert"
              >
                {values.map((x) => x).join(", ") || translator("Pos")}
              </div>
            )}
          </div>
          <br />
          <div className="form-group">
            <label>{translator("Administration-PosVersion-Name")}</label>

            <select
              className="form-control"
              name="posVersionId"
              onChange={(e) => {
                setSelectedVersion(e.target.value);
              }}
            >
              <option value="0">{translator("Select-Version")}</option>
              {posVersions?.map((item) => (
                <option key={item?.id} value={item.id}>
                  {translator(item?.name)}
                </option>
              ))}
            </select>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => setShowFileModal(false)}
            className="btn btn-outline-secondary"
          >
            {translator("Btn-Cancel")}
          </button>
          <button
            appearance="primary"
            onClick={handleSaveFile}
            className="btn btn-primary"
            disabled={!values?.length}
          >
            {translator("Btn-Save")}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ImportFileModal;
